export default "__VITE_ASSET__BnkESDiG__"